import React, { useEffect, useState } from "react"
import {
  Button,
  Col,
  Form,
  Input,
  message,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Table,
} from "antd"
import { unwrapResult } from "@reduxjs/toolkit"
import layout from "antd/lib/layout"
import { useDispatch, useSelector } from "react-redux"
import { RootDispatch } from "../../../app/store"
import { DateSelect } from "../../../compnents/form/DateSelect"
import { CloseOutlined, PlusOutlined, SearchOutlined } from "@ant-design/icons"
import { stringTrim } from "../../../utils/StringUtils"
import FileUpload from "../../../compnents/file/FileUpload"
import Upload, { RcFile } from "antd/lib/upload"
import { UploadFile } from "antd/lib/upload/interface"
import styles from "../filing.module.css"
import { DoctorFormModal } from "./DoctorFormModal"
import axios from "axios"
import { selectCredentials, selectTenantName } from "../../../app/applicationSlice"
import { selectTenant } from "../../user/setting/settingSlice"
import moment from "moment"
import { DateTimeFormatSimpleOnly } from "../../../models/datetime"
import { AXIOS_IP, downloadFile, SUPPORTED_IMAGE_TYPES } from "../fileUploadService"

export const ZYTFFormModal = (props: {
  visible: boolean
  token: string
  againId?: string
  memo?: string
  onOk: () => void
  onCancel: () => void
}) => {
  const { Option } = Select

  const { TextArea } = Input

  const dispatch = useDispatch<RootDispatch>()

  const credentials: any = useSelector(selectCredentials)

  const tenantName = useSelector(selectTenantName)

  const tenant = useSelector(selectTenant)

  const [form] = Form.useForm()

  const [doctorVisible, setDoctorVisible] = useState(false)

  const [submitVisible, setSubmitVisible] = useState(false)

  const [doctorlist, setDoctorlist] = useState<any>([])

  const [updateDoctor, setUpdateDoctor] = useState<any>({})

  const [fileGLUrl, setfileGLUrl] = useState<any>([]) //管理制度及技术

  const [fileFXUrl, setfileFXUrl] = useState<any>([]) //风险防范及不良反应

  const [fileYSUrl, setfileYSUrl] = useState<any>([]) //医学伦理审查意见表

  const [confirmLoading, setConfirmLoading] = useState(false)

  const [baseUrl, setBaseUrl] = useState("")
  
  const [isModalVisible, setIsModalVisible] = useState(false) //预览

  const inputRef = React.useRef<any>(null)

  //管理制度及技术操作规范模板
  const templateData = {
    fileConfigId: "5",
    fileName: "管理制度及技术操作规范模板",
    fileType: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    filePath: "ab08b428bf6639a8c923368e537150b40776eb94922180a06473700fff17caa8.docx",
  }


  // 处理文件上传前操作
  const beforeUploadFile = (file: File, urls: []) => {
    if (urls.length >= 3) {
      message.error("最多只能上传3个文件!")
      return Upload.LIST_IGNORE
    }
    const isPdf = file.type === "application/pdf"

    if (!isPdf && !SUPPORTED_IMAGE_TYPES.includes(file.type)) {
      message.error("仅支持pdf和图片文件格式上传")
      return false
    }
    const isLt2M = file.size / 1024 / 1024 < 10
    if (!isLt2M) {
      message.error("文件太大，不能超过10M")
    }
    return isLt2M
  }
  // 自定义上传实现
  const customRequest = async (
    { file, onSuccess, onError, onProgress }: any,
    type: string
  ) => {
    const formData = new FormData()
    formData.append("file", file)
    formData.append("name", file.name)
    try {
      // 使用axios发送请求
      const response = await axios.post(
        `${AXIOS_IP}/infra/file/uploadFile`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
          onUploadProgress: (progressEvent) => {
            const percent = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            )
            onProgress({ percent })
          },
        }
      )
      if (response.data) {
        const data = response.data
        switch (type) {
          case "GL":
            setfileGLUrl([
              ...fileGLUrl,
              { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
            ])
            break
          case "FX":
            setfileFXUrl([
              ...fileFXUrl,
              { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
            ])
            break
          case "YS":
            setfileYSUrl([
              ...fileYSUrl,
              { fileConfigId: data?.configId, fileName: data?.name, fileType: data?.type, filePath: data?.path },
            ])
            break
        }
      }
      onSuccess(response.data)
      message.success(`上传成功`)
    } catch (error) {
      message.error(`上传失败`)
    }
  }

  const handleRemove = (type: string, index: number) => {
    switch (type) {
      case "GL":
        setfileGLUrl(fileGLUrl?.filter((v: any, i: number) => i !== index))
        break
      case "FX":
        setfileFXUrl(fileFXUrl?.filter((v: any, i: number) => i !== index))
        break
      case "YS":
        setfileYSUrl(fileYSUrl?.filter((v: any, i: number) => i !== index))
        break
    }
  }

   const getBase64Url = (v: any, type = false) => {
    axios({
      url: `${AXIOS_IP}/infra/file/downloadFile/${v.fileConfigId}/${v.filePath}`,
      headers: {
        "Content-Type": "application/json",
        "His-Auth": props.token,
      },
      withCredentials: false,
      method: "GET",
    }).then((res: any) => {
      if(type) {
        const link = document.createElement('a');
        link.href = `data:${v.fileType};base64,${res.data}`
        link.download = '参考模板.docx'
        document.body.appendChild(link)
        link.click()
        document.body.removeChild(link)
      } else {
        setBaseUrl(`data:${v.fileType};base64,${res.data}`)
        setIsModalVisible(true)
      }
    }).catch((err) => { console.error(err) })
  }

  useEffect(() => {
    form.setFieldsValue({
      professionalTitleCertificateFileUrl: fileGLUrl,
    })
  }, [fileGLUrl])

  useEffect(() => {
    form.setFieldsValue({
      professionalTitleCertificateFileUrl: fileFXUrl,
    })
  }, [fileFXUrl])

  useEffect(() => {
    form.setFieldsValue({
      professionalTitleCertificateFileUrl: fileYSUrl,
    })
  }, [fileYSUrl])

  useEffect(() => {
    form.setFieldsValue({
      filingDoctorInfoDtoList: doctorlist,
    })
  }, [doctorlist])

  useEffect(() => {
    if(!props.visible) {
      form.resetFields()
      setDoctorlist([])
      setfileFXUrl([])
      setfileGLUrl([])
      setfileYSUrl([])
    } else {
      if(props.againId) {
        axios({
          url: `${AXIOS_IP}/filingReviewTcmPatchRecord/detail`,
          headers: {
            "Content-Type": "application/json",
            "His-Auth": props.token,
          },
          withCredentials: false,
          method: "POST",
          data: { id: props.againId },
        }).then(res => {
          if(res.data.data) {
            const data= res.data.data
            form.setFieldsValue({...data})
            setDoctorlist(data?.doctorInfoList?.map((v: any) => {
              return {
                ...v,
                fileZGUrl: v.professionalQualificationCertificateFileUrl || [],
                fileZCUrl: v.professionalTitleCertificateFileUrl || [],
                fileYSUrl: v.practiceCertificateFileUrl || [],
                fileJGUrl: v.institutionReviewFileUrl || [],
              }
            }))
            setfileFXUrl(data?.riskPreventionFileUrl || [])
            setfileGLUrl(data?.managementSystemFileUrl || [])
            setfileYSUrl(data?.medicalEthicsFileUrl || [])
          }
        }).catch((err) => { console.error(err) })
      } else {
        setTimeout(() => {
          if(inputRef?.current) {
            inputRef.current.focus?.()
          }
        }, 100)
      }
    }
  }, [props.visible, inputRef])

  return (
    <>
      <Modal
        title="中医冬病夏治穴位贴敷备案"
        width={1000}
        visible={props?.visible}
        onCancel={() => {
          props?.onCancel()
        }}
        onOk={form.submit}
        okText="提交"
        centered
        maskClosable={false}
      >
        <div style={{ height: 600, overflow: "auto" }}>
          <Form
            form={form}
            labelCol={{ span: 6 }}
            wrapperCol={{ span: 18 }}
            style={{ paddingRight: 10 }}
            onFinish={(vs) => {
              if (!doctorlist.length) {
                message.error("请添加医师")
                return
              }
              setSubmitVisible(true)
            }}
          >
            <Row>
              <Col span={24}>
                <Form.Item
                  name="diseasesTreated"
                  label="诊疗病种"
                  rules={[{ required: true }]}
                >
                  <TextArea ref={inputRef} allowClear showCount maxLength={500} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="prescriptionMedication"
                  label="处方用药"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="dosagePerTreatment"
                  label="每次治疗剂量"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="drugName"
                  label="名称"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="acuPoint"
                  label="穴位"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={100} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="拟定处方的医师名单"
                  name="filingDoctorInfoDtoList"
                  rules={[{ required: true }]}
                >
                  <Button type="primary" onClick={() => {
                    setUpdateDoctor({})
                    setDoctorVisible(true)
                  }}>
                    添加医师
                  </Button>
                  <Table
                    dataSource={doctorlist}
                    className={styles.QATable}
                    columns={[
                      {
                        title: "医生姓名",
                        align: "left",
                        width: "8rem",
                        ellipsis: true,
                        dataIndex: "name",
                      },
                      {
                        title: "人员类型",
                        align: "left",
                        width: "8rem",
                        ellipsis: true,
                        dataIndex: "personnelTypeName",
                      },
                      {
                        title: "操作",
                        align: "center",
                        width: "8rem",
                        ellipsis: true,
                        render: function Element(_, m) {
                          return (
                            <Space>
                              <Button
                                type="link"
                                onClick={() => {
                                  setUpdateDoctor(m)
                                  setDoctorVisible(true)
                                }}
                              >
                                编辑
                              </Button>
                              <Button
                                type="link"
                                onClick={() => {
                                  setDoctorlist(
                                    doctorlist?.filter(
                                      (v: any) =>
                                        v.idCardNumber !== m.idCardNumber
                                    )
                                  )
                                }}
                              >
                                删除
                              </Button>
                            </Space>
                          )
                        },
                      },
                    ]}
                    rowKey={(t: any) => t.idCardNumber}
                    pagination={false}
                    style={{
                      marginTop: "13px",
                    }}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="contraindicationsAndRelatedPrecautions"
                  label="禁忌症及相关注意事项"
                  rules={[{ required: true }]}
                >
                  <TextArea allowClear showCount maxLength={500} />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  name="filingNumber"
                  label="备案号"
                  rules={[{ required: true }]}
                >
                  <Input allowClear />
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="管理制度及技术操作规范"
                  name="managementSystemFileUrl"
                  rules={[{ required: true, message: "请上传管理制度及技术操作规范" }]}
                >
                  <Row align="middle">
                    <Upload
                      customRequest={(options) => customRequest(options, "GL")}
                      beforeUpload={(file) => beforeUploadFile(file, fileGLUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <span style={{ padding: "0 10px 0 15px" }}>
                      支持pdf和图片文件格式上传
                    </span>
                    <a style={{ textDecoration: "underline", paddingRight: 10 }} onClick={() => downloadFile(templateData, props.token, 'docx')}>参考模板</a>
                    {fileGLUrl?.length > 0 &&
                      fileGLUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span
                              style={{ paddingRight: 10 }}
                            >
                              {v.fileName} <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("GL", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="风险防范及不良反应处置预案"
                  name="riskPreventionFileUrl"
                  rules={[{ required: true, message: "请上传风险防范及不良反应处置预案" }]}
                >
                  <Row align="middle">
                    <Upload
                      customRequest={(options) => customRequest(options, "FX")}
                      beforeUpload={(file) => beforeUploadFile(file, fileFXUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <span style={{ padding: "0 10px 0 15px" }}>
                      支持pdf和图片文件格式上传
                    </span>
                    {fileFXUrl?.length > 0 &&
                      fileFXUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span
                              style={{ paddingRight: 10 }}
                            >
                              {v.fileName} <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("FX", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
            <Row>
              <Col span={24}>
                <Form.Item
                  label="医学伦理审查意见表"
                  name="medicalEthicsFileUrl"
                  rules={[{ required: true, message: "请上传医学伦理审查意见表" }]}
                >
                  <Row align="middle">
                    <Upload
                      customRequest={(options) => customRequest(options, "YS")}
                      beforeUpload={(file) => beforeUploadFile(file, fileYSUrl)}
                      showUploadList={false}
                      maxCount={3}
                      accept={".pdf,.jpg,.jpeg,.png,.gif"}
                    >
                      <Button icon={<PlusOutlined />}>上传</Button>
                    </Upload>
                    <span style={{ padding: "0 10px 0 15px" }}>
                      支持pdf和图片文件格式上传
                    </span>
                    {/* <a style={{ textDecoration: "underline", paddingRight: 10 }} onClick={() => getBase64Url(templateData, true)}>参考模板</a> */}
                    {fileYSUrl?.length > 0 &&
                      fileYSUrl?.map((v: any, index: number) => {
                        return (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "center",
                              cursor: "pointer",
                              paddingRight: 10,
                            }}
                          >
                            <span
                              style={{ paddingRight: 10 }}
                            >
                              {v.fileName} <a style={{ paddingLeft: 10 }} onClick={() => getBase64Url(v)}>查看</a>
                            </span>
                            <CloseOutlined
                              style={{
                                position: "relative",
                                top: 2,
                                color: "rgb(161 161 161)",
                              }}
                              onClick={() => {
                                handleRemove("YS", index)
                              }}
                            />
                          </div>
                        )
                      })}
                  </Row>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>

      <DoctorFormModal
        visible={doctorVisible}
        updateDoctor={updateDoctor}
        token={props.token}
        AXIOS_IP={AXIOS_IP}
        onOk={(data) => {
          const filterlist = doctorlist.filter(
            (item: any) => item.idCardNumber == data.idCardNumber
          )
          if (filterlist.length > 0) {
            setDoctorlist(
              doctorlist?.map((item: any) => {
                if (item.idCardNumber == data.idCardNumber) {
                  return data
                } else {
                  return item
                }
              })
            )
          } else {
            setDoctorlist([...doctorlist, {...data}])
          }
          setDoctorVisible(false)
        }}
        onCancel={() => setDoctorVisible(false)}
      />

      <Modal
        title="提交申请"
        width={450}
        visible={submitVisible}
        onCancel={() => setSubmitVisible(false)}
        confirmLoading={confirmLoading}
        onOk={() => {
          setConfirmLoading(true)
          const data = {
            ...form.getFieldsValue(),
            doctorInfoList: doctorlist?.map((v: any) => {
              return {
                ...v,
                birthDate: v.birthDate ? moment(v.birthDate).format(DateTimeFormatSimpleOnly) : undefined,
                workStartDate: moment(v.workStartDate).format(DateTimeFormatSimpleOnly),
              }
            }),
            applicantId: credentials.userId,
            applicantName: credentials.userName,
            managementSystemFileUrl: fileGLUrl,
            riskPreventionFileUrl: fileFXUrl,
            medicalEthicsFileUrl: fileYSUrl,
            id: props.againId,
            memo: props.memo,
          }
          axios({
            url: `${AXIOS_IP}/filingReviewTcmPatchRecord/save`,
            headers: {
              "Content-Type": "application/json",
              "His-Auth": props.token,
            },
            withCredentials: false,
            method: "POST",
            data,
          }).then((res) => {
            if (res.data?.data || res.data?.success) {
              setSubmitVisible(false)
              notification.success({
                message: '操作成功',
              })
              props.onOk()
            } else {
              notification.error({
                message: res.data?.msg || '操作失败，请稍后重试',
              })
            }
          }).catch(() => {
            notification.error({
              message: '请求异常，请稍后重试',
            })
          }).finally(() => {
            setConfirmLoading(false)
          })
        }}
        okText="确认提交"
        centered
        maskClosable={false}
      >
        <Row style={{ height: 50 }}>
          提交后请耐心等待工作人员审核
        </Row>
      </Modal>

      <Modal
        title={'预览'}
        visible={isModalVisible}
        footer={null}
        width={'80%'}
        onCancel={() => {
          setIsModalVisible(false)
        }}
      >
        <div style={{ height: '650px' }}>
          <iframe
            title='预览'
            style={{ width: '100%', height: '100%' }}
            src={baseUrl}
          />
        </div>
      </Modal>
    </>
  )
}
